import { render, staticRenderFns } from "./RoomModal.vue?vue&type=template&id=60f6c701&scoped=true&"
import script from "./RoomModal.vue?vue&type=script&lang=js&"
export * from "./RoomModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f6c701",
  null
  
)

export default component.exports